function initFreshChat() {
        window.fcWidget.init({
          	 token: "c74bac7c-8731-4718-9626-5aaa93a37ddb",
    	 host: "https://tinadavies.freshchat.com"
        });
        window.fcWidget.show();
      }
      function initialize(i,t){var e;i.getElementById(t)?
      initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,
      e.src="https://tinadavies.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}
      function initiateCall(){initialize(document,"freshchat-js-sdk")}
      window.addEventListener?window.addEventListener("load",initiateCall,!1):
      window.attachEvent("load",initiateCall,!1);